import { travelEsimClient } from '@/lib/api/ts-rest';
import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';

/** Current version of the international eSIM tariff grid (Octave admin). */
export function useTravelEsimTariffGrid() {
  return useQuery({
    queryKey: queryKeys.catalog.travelEsimGrid(),
    queryFn: async () => {
      const res = await travelEsimClient.getCurrentTariffGrid();
      if (res.status !== 200) throw new Error('Failed to load tariff grid');
      return res.body;
    },
  });
}
